import React, { useState } from 'react';
import styles from './AIEnhanceField.module.css';
import { api, endpoints } from '../apiConfig';

const AIEnhanceField = ({ 
  value, 
  onChange, 
  section, 
  placeholder 
}) => {
  const [isEnhancing, setIsEnhancing] = useState(false);
  const [enhancedContent, setEnhancedContent] = useState(null);
  const [error, setError] = useState(null);

  const handleEnhance = async () => {
    try {
      setIsEnhancing(true);
      setError(null);

      const response = await api.post(endpoints.user.enhance, {
        content: value,
        section
      });

      if (response.data.enhanced) {
        setEnhancedContent(response.data.enhanced);
      } else {
        throw new Error('No enhanced content received');
      }
    } catch (error) {
      console.error('Enhancement error:', error);
      setError(error.response?.data?.message || error.message || 'Failed to enhance content. Please try again.');
    } finally {
      setIsEnhancing(false);
    }
  };

  const handleUseEnhanced = () => {
    onChange(enhancedContent);
    setEnhancedContent(null);
  };

  const handleKeepOriginal = () => {
    setEnhancedContent(null);
  };

  return (
    <div className={styles.container}>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className={styles.textarea}
      />
      
      <div className={styles.controls}>
        <button
          onClick={handleEnhance}
          disabled={isEnhancing || !value}
          className={styles.enhanceButton}
        >
          {isEnhancing ? 'Enhancing...' : '✨ Enhance with AI'}
        </button>
      </div>

      {error && (
        <div className={styles.error}>
          {error}
        </div>
      )}

      {enhancedContent && (
        <div className={styles.previewContainer}>
          <h4>Enhanced Version</h4>
          <div className={styles.preview}>{enhancedContent}</div>
          <div className={styles.previewControls}>
            <button
              onClick={handleKeepOriginal}
              className={styles.keepButton}
            >
              Keep Original
            </button>
            <button
              onClick={handleUseEnhanced}
              className={styles.useButton}
            >
              Use Enhanced Version
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AIEnhanceField; 